import { theme } from '@atlas/shared/client/ui/core/theming';
import { css, unsafeCSS } from 'lit';
export const chatbotMessageRatingStyles = css`
    :host {
        display: flex;
        flex-direction: row;
        margin-top: 0.5rem;
    }
    lr-icon-button::part(base) {
        color: ${unsafeCSS(theme.colors.base.greys.tone600)};
    }
    lr-icon-button[data-toggled]::part(base) {
        color: ${unsafeCSS(theme.colors.base.greys.tone900)};
    }
    lr-icon-button[icon='thumb-up'][data-toggled]::part(base) {
        color: ${unsafeCSS(theme.colors.base.success.tone600)};
    }
`;
